/**
 * Service Profil - API Tracking
 * GET /api/users/profile/, changement de mot de passe.
 */
import { createTrackingClient } from "../trackingApi";

export interface TrackingProfile {
  id?: number;
  user_id?: number;
  username: string;
  email: string | null;
  first_name?: string;
  last_name?: string;
  phone_number?: string | null;
  profile_picture?: string | null;
  profile_image?: string | null;
}

export interface ChangePasswordPayload {
  old_password: string;
  new_password: string;
  confirm_password: string;
}

function getClient(accessToken: string | undefined) {
  return createTrackingClient(accessToken);
}

/**
 * Récupère le profil utilisateur (Tracking).
 */
export async function fetchTrackingProfile(
  accessToken: string | undefined
): Promise<TrackingProfile> {
  const client = getClient(accessToken);
  const { data } = await client.get<TrackingProfile>("/api/users/profile/");
  return data;
}

/**
 * Change le mot de passe de l'utilisateur connecté.
 * Body: old_password, new_password, confirm_password
 */
export async function changeTrackingPassword(
  accessToken: string | undefined,
  payload: ChangePasswordPayload
): Promise<{ message?: string }> {
  const client = getClient(accessToken);
  const { data } = await client.post("/api/users/change-password/", payload);
  return data;
}
